import React , {Component } from 'react';
import AUX from '../../hoc/Aux_';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import { Alert, AlertTitle } from '@material-ui/lab';
import {fetchKategori, fetchUnsur, fetchUnsurDetail } from '../../api/kugi';
import Divider from '@material-ui/core/Divider';
import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support
import Config from "../../config/";
const ROOT_URL = Config.rooturl;
function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

function TransitionComponent(props) {
  const style = useSpring({
    from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
  },
}))((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
  },
});


class UnduhBukuKugi extends Component{

    constructor(props) {
      super(props);
      this.state = {

        code:"",

      };
    }

    render(){
        return(
          <AUX>
            <section className="sections" style = {{paddingTop:"4%"}}>
              <div className="container">
              <div className="row justify-content-center" >
              <a href="https://5stardata.info/en/" className="section-subtitle text-dark pt-3"><img src="images/5star.PNG"/></a>
              </div>         
                <div className="row justify-content-center" >

                  <Grid item xs={9} style = {{paddingLeft:"10px"}}>
                  <Paper >
                  <Alert severity="info">
                    Unduh Skema RDF
                  </Alert>
                  <TreeView
                    defaultExpanded={['4444']}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                  >

                    <StyledTreeItem nodeId="4444" label="Struktur RDF">
                      <StyledTreeItem nodeId="44441" label="BATAS WILAYAH" onClick={()=>{window.open("/data/rdf/featurecatalog2.rdf");}}/>
                      <StyledTreeItem nodeId="444414" label="TRANSPORTASI"  onClick={()=>{window.open("/data/rdf/featurecatalog3.rdf");}}/>
                      <StyledTreeItem nodeId="444413" label="HIDROGRAFI"  onClick={()=>{window.open("/data/rdf/featurecatalog4.rdf");}}/>
                      <StyledTreeItem nodeId="44443" label="HIPSOGRAFI" onClick={()=>{window.open("/data/rdf/featurecatalog5.rdf");}}/>
                      <StyledTreeItem nodeId="44444" label="VEGETASI"  onClick={()=>{window.open("/data/rdf/featurecatalog6.rdf");}}/>
                      <StyledTreeItem nodeId="444411" label="LINGKUNGAN TERBANGUN"  onClick={()=>{window.open("/data/rdf/featurecatalog7.rdf");}}/>
                      <StyledTreeItem nodeId="444412" label="UTILITAS"  onClick={()=>{window.open("/data/rdf/featurecatalog8.rdf");}}/>
                      <StyledTreeItem nodeId="44446" label="GEOLOGI"  onClick={()=>{window.open("/data/rdf/featurecatalog9.rdf");}}/>
                      <StyledTreeItem nodeId="44442" label="TANAH" onClick={()=>{window.open("/data/rdf/featurecatalog10.rdf");}}/>
                      <StyledTreeItem nodeId="44447" label="REFERENSI SPASIAL"  onClick={()=>{window.open("/data/rdf/featurecatalog1.rdf");}}/>
                      <StyledTreeItem nodeId="44448" label="TOPONIMI"  onClick={()=>{window.open("/data/rdf/featurecatalog11.rdf");}}/>
                      <StyledTreeItem nodeId="44449" label="KADASTER"   onClick={()=>{window.open("/data/rdf/featurecatalog12.rdf");}}/>
                      <StyledTreeItem nodeId="444410" label="KEBENCANAAN"   onClick={()=>{window.open("/data/rdf/featurecatalog13.rdf");}}/>
                      <StyledTreeItem nodeId="44445" label="DATASET KHUSUS"  onClick={()=>{window.open("/data/rdf/featurecatalog14.rdf");}}/>
                      <StyledTreeItem nodeId="444415" label="PERENCANAAN"  onClick={()=>{window.open("/data/rdf/featurecatalog15.rdf");}}/>

                    </StyledTreeItem> 
                  </TreeView>
                  </Paper>
                  </Grid>
                </div>
              </div>
            </section>
          </AUX>
        );
    }
}

export default UnduhBukuKugi;
